// Constantes compartidas del modulo Fichas de Paciente.

export const PREDEFINED_TAGS = [
  { value: 'vip', label: 'VIP' },
  { value: 'nuevo', label: 'Nuevo' },
  { value: 'recurrente', label: 'Recurrente' },
  { value: 'en_seguimiento', label: 'En seguimiento' },
];

export function tagLabel(value) {
  const found = PREDEFINED_TAGS.find((t) => t.value === value);
  if (found) return found.label;
  return value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, ' ');
}

export const TAG_COLORS = {
  vip: 'bg-[#F4E4D6] text-[#B5793A]',
  nuevo: 'bg-[#E3EDE1] text-[#5B7A54]',
  recurrente: 'bg-brand-light text-brand',
  en_seguimiento: 'bg-[#F4E1E1] text-[#A34B49]',
};

export const DEFAULT_TAG_COLOR = 'bg-muted text-muted-foreground';

export const PHOTO_TYPE_LABELS = {
  before: 'Antes',
  after: 'Despues',
  general: 'General',
};

export const PAYMENT_METHOD_LABELS = {
  cash: 'Efectivo',
  card: 'Tarjeta',
  transfer: 'Transferencia',
  zelle: 'Zelle',
  cherry: 'Cherry', // Fix BC (2026-10-30): solo para "Aceptamos..." de la página; no se usa para registrar pagos
  other: 'Otro',
};

export const PAYMENT_METHODS = ['cash', 'card', 'transfer', 'zelle', 'other'];
